import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { SysKisiService } from '../ctl-sys-kisi.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: SysKisiService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([
                'Kod',
                'Tckn',
                'Ad',
                'Soyad',
            ]);

            const filterArr = [];
            if(this.service.isActive) filterArr.push(['AktifEh', '=', 'E']);
            if(filterArr.length > 0) dataSource.filter(filterArr)
            return dataSource;
    }

}
